import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataMateriaPrima from "./dataMateriaPrima";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const MateriaPrima = ({ listadoMateriaPrima }) => {
  const { columns, getRows } = dataMateriaPrima;

  const memoizedRows = useMemo(() => {
    if (listadoMateriaPrima) {
      const listadoSinBorrar = listadoMateriaPrima.filter((item) => !item.borrado);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoMateriaPrima]);

  return (
    <Grid container p={2}>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="flex-end">
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Materias Primas
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoMateriaPrima?.length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay materias primas cargadas" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(MateriaPrima);

MateriaPrima.propTypes = {
  listadoMateriaPrima: PropTypes.array.isRequired,
};
